import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';

function CreateCoOwnerModal({
  createInput,
  createTelephoneNumber,
  createCoOwner,
  formData,
  getLandOwnerList,
  history,
  id,
  getSingleLandOwner,
}) {

  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const payload  = {
      ...formData,
      ownerId: id
    }
    createCoOwner(payload, () => {
      setModal({ isOpen: false });
      getLandOwnerList();
      history.push(`/rpt/land/land-owner/${payload.ownerId}`);
      getSingleLandOwner(payload.ownerId);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            {createInput(
              { key: 'name', label: 'Name:' },
              { required: true }
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'address', label: 'Address:' },
              { required: true }
            )}
          </div>
          <div className="col-12 form-group">
            {createTelephoneNumber(
              { key: 'telephone_no', label: 'Telephone No.:' },
              { required: true }
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'tin', label: 'TIN:' },
              { required: true, type: 'number' }
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button type="submit" className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3">
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateCoOwnerModal.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
  createTelephoneNumber: PropTypes.instanceOf(Function).isRequired,
  getLandOwnerList: PropTypes.instanceOf(Function).isRequired,
  createCoOwner: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  id: PropTypes.string.isRequired,
  getSingleLandOwner: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateCoOwnerModal);
